import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogRadioButtonGroup from "@/shared/ui/SogRadioButtonGroup.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";

import {ref} from "vue";

import Person from "@/shared/model/person";
import {reactive, watch} from "vue";
import SogRadioButtonGroupItem from "@/shared/ui/types/SogRadioButtonGroupItem";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";

interface Props {
  person: Person,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonEditFormComponent',
  props: {
    person: { default: () => new Person() }
  },
  setup(__props: any, { expose: __expose }) {


const props = __props;

const _form = ref<InstanceType<typeof SogForm> | null>(null)
const _value = reactive({person: props.person})
const _sexItems: SogRadioButtonGroupItem[] = [{label: "Herr", value: "M"}, {label: "Frau", value: "W"}]

const _validations: SogFormValidationRule[] = [
  {name: 'Nachname', rules: {required: [true, "Geben Sie einen Namen ein."]}},
]

watch(props, () => {
    _value.person = props.person;
  }, {immediate: true}
)
const validate = (): boolean => {
  if (_form.value)
    return _form.value.validate();
  return false;
}

const getPerson = (): Person => {
  return _value.person;
}
__expose({
  validate, getPerson
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form,
    validations: _validations
  }, {
    default: _withCtx(() => [
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogRadioButtonGroup, {
            modelValue: _value.person.sex,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_value.person.sex) = $event)),
            items: _sexItems,
            name: "Sex"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _value.person.name2,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_value.person.name2) = $event)),
            placeholder: "Vorname",
            autocomplete: "true",
            name: "Vorname"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _value.person.name1,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_value.person.name1) = $event)),
            placeholder: "Nachname*",
            autocomplete: "true",
            name: "Nachname"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})